// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --blue-main: #0A3760;
    --blue-light: #1B5D9B;
    --bg: #ffffff;
    --nav-width: 235px;       /* width of logo and left nav */
    --topbar-height: 80px;   /* height of the top bar / logo block */
  }
  
  /* Base */
  html, body, #root {
    height: 100%;
    margin: 0;
    font-family: 'Arial Nova', Arial, sans-serif;
  }
  .app-shell {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  
  /* Top bar */
  .topbar {
    height: var(--topbar-height);
    background: var(--blue-main);
    color: #fff;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 0 16px 0 0;
  }
  
  .topbar-left {
    flex: 0 0 var(--nav-width);
    width: var(--nav-width);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .logo {
    height: var(--topbar-height);
    width: auto;
    object-fit: contain;
  }
  
  .topbar-title {
    flex: 1 1;
    text-align: center;
    font-size: 30px;      /* project name font size */
    font-weight: 700;
  }
  
  .topbar-right {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 20px;      /* date/time font size */
    white-space: nowrap;
  }
  
  .logout {
    border: 0;
    background: transparent;
    color: #fff;
    cursor: pointer;
    border-radius: 8px;
    padding: 6px 8px;
  }
  .logout:hover { background: rgba(255,255,255,.12); }
  
  /* Body + Sidenav */
  .body {
    display: flex;
    flex: 1 1;
    min-height: calc(100vh - var(--topbar-height));
  }
  
  .sidenav {
    width: var(--nav-width);
    background: var(--blue-main);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 200px;         /* push menu down below logo area */
  }
  
  .navlink {
    color: #fff;
    text-decoration: none;
    padding: 14px 20px;
    font-weight: 600;
    font-size: 20px;           /* left navigation font size */
  }
  .navlink:hover { background: rgba(255,255,255,.08); }
  .navlink.active { background: var(--blue-light); }
  
  .content {
    flex: 1 1;
    padding: 20px;
    background: var(--bg);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/layout/Layout.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,kBAAkB,QAAQ,+BAA+B;IACzD,qBAAqB,IAAI,uCAAuC;EAClE;;EAEA,SAAS;EACT;IACE,YAAY;IACZ,SAAS;IACT,4CAA4C;EAC9C;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,4BAA4B;IAC5B,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,eAAe,OAAO,2BAA2B;IACjD,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe,OAAO,wBAAwB;IAC9C,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA,gBAAgB,iCAAiC,EAAE;;EAEnD,mBAAmB;EACnB;IACE,aAAa;IACb,SAAO;IACP,8CAA8C;EAChD;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB,UAAU,mCAAmC;EACjE;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,YAAY,8BAA8B;EAC3D;EACA,iBAAiB,iCAAiC,EAAE;EACpD,kBAAkB,6BAA6B,EAAE;;EAEjD;IACE,SAAO;IACP,aAAa;IACb,qBAAqB;EACvB","sourcesContent":[":root {\n    --blue-main: #0A3760;\n    --blue-light: #1B5D9B;\n    --bg: #ffffff;\n    --nav-width: 235px;       /* width of logo and left nav */\n    --topbar-height: 80px;   /* height of the top bar / logo block */\n  }\n  \n  /* Base */\n  html, body, #root {\n    height: 100%;\n    margin: 0;\n    font-family: 'Arial Nova', Arial, sans-serif;\n  }\n  .app-shell {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n  }\n  \n  /* Top bar */\n  .topbar {\n    height: var(--topbar-height);\n    background: var(--blue-main);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 0 16px 0 0;\n  }\n  \n  .topbar-left {\n    flex: 0 0 var(--nav-width);\n    width: var(--nav-width);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .logo {\n    height: var(--topbar-height);\n    width: auto;\n    object-fit: contain;\n  }\n  \n  .topbar-title {\n    flex: 1;\n    text-align: center;\n    font-size: 30px;      /* project name font size */\n    font-weight: 700;\n  }\n  \n  .topbar-right {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    font-size: 20px;      /* date/time font size */\n    white-space: nowrap;\n  }\n  \n  .logout {\n    border: 0;\n    background: transparent;\n    color: #fff;\n    cursor: pointer;\n    border-radius: 8px;\n    padding: 6px 8px;\n  }\n  .logout:hover { background: rgba(255,255,255,.12); }\n  \n  /* Body + Sidenav */\n  .body {\n    display: flex;\n    flex: 1;\n    min-height: calc(100vh - var(--topbar-height));\n  }\n  \n  .sidenav {\n    width: var(--nav-width);\n    background: var(--blue-main);\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding-top: 200px;         /* push menu down below logo area */\n  }\n  \n  .navlink {\n    color: #fff;\n    text-decoration: none;\n    padding: 14px 20px;\n    font-weight: 600;\n    font-size: 20px;           /* left navigation font size */\n  }\n  .navlink:hover { background: rgba(255,255,255,.08); }\n  .navlink.active { background: var(--blue-light); }\n  \n  .content {\n    flex: 1;\n    padding: 20px;\n    background: var(--bg);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
